var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "interface-area invest" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global", visible: true },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("InvestToken", {
                  attrs: {
                    method: _vm.method,
                    balance: _vm.user !== null ? _vm.user.dfp_balance : 0,
                    price: _vm.price,
                  },
                  on: {
                    initSuccess: _vm.showSuccessMessage,
                    closeGlobalModal: _vm.closeModal,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "transaction-box invest-block" }, [
        _c("div", { staticClass: "left-area" }, [
          _c("div", { staticClass: "level-area" }, [
            _c("div", { staticClass: "level-icon" }, [
              _c(
                "div",
                {
                  staticClass: "current-level",
                  style: {
                    background:
                      _vm.currentLevel !== null
                        ? _vm.currentLevel.color
                        : "linear-gradient(215deg, #2B18FF 19.48%, #34AEFE 95.82%)",
                  },
                },
                [
                  _c("div", { staticClass: "first-gradient" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "second-gradient" }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _vm.user !== null
                ? _c("div", { staticClass: "h1" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("invest.your_level_is")) +
                        "\n            " +
                        _vm._s(
                          _vm.currentLevel !== null
                            ? _vm.currentLevel.name
                            : "..."
                        ) +
                        "\n          "
                    ),
                  ])
                : _c("div", { staticClass: "h1" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("invest.login_to_benefit")) +
                        "\n          "
                    ),
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.level_desc")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.user !== null
            ? _c("div", { staticClass: "level-info" }, [
                _c("div", { staticClass: "text-info" }, [
                  _c("p", { staticClass: "paragraph" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("invest.bonus_tokens")) +
                        "\n            "
                    ),
                    _c("span", { staticClass: "colored" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.currentLevel !== null
                              ? _vm.$priceFormat(_vm.currentLevel.discount, 1)
                              : "..."
                          ) +
                          "%\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.nextLevel !== null && _vm.currentLevel !== null
                    ? _c("p", { staticClass: "paragraph smaller" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("invest.more_tokens", {
                                tokens:
                                  _vm.nextLevel.from - _vm.user.dfp_balance,
                              })
                            ) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "colored" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.nextLevel.name) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("invest.level")) +
                            ".\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "action-buttons" }, [
                  _vm.user !== undefined && _vm.user !== null
                    ? _c(
                        "button",
                        {
                          staticClass: "btn cyan",
                          attrs: { type: "button" },
                          on: { click: _vm.googleform },
                        },
                        [
                          _vm._v(
                            "  \n            " +
                              _vm._s(_vm.$t("invest.buy_dfp")) +
                              "\n          "
                          ),
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn cyan",
                          attrs: { type: "button" },
                          on: { click: _vm.openConnectModal },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.connect_wallet")) +
                              "\n          "
                          ),
                        ]
                      ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "stats" }, [
            _c("div", { staticClass: "stat" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.price")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.price) + " USDT\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.total_suply")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$priceFormat(_vm.totalSupply, 0)) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.blockchain")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v("\n            Binance Smart Chain (BSC)\n          "),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider horizontal" }),
        _vm._v(" "),
        _c("div", { staticClass: "right-area" }, [
          _c("div", { staticClass: "balance-area" }, [
            _c("h1", { staticClass: "title" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("invest.invest")) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "balance-info" }, [
              _c("div", { staticClass: "balance" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("invest.my_balance")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "numbers" }, [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: "/img/new/floatie-token.webp",
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("nuxt-img", {
                        attrs: {
                          fit: "inside",
                          src: "/img/new/floatie-token.png",
                          alt: "Buy Defi Pool token (DFP) to get rewards, discounts and better staking/farming percent",
                          title: "Buy $DFP token",
                          loading: "lazy",
                          placeholder: "",
                          quality: 80,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.user !== null
                          ? _vm.$priceFormat(_vm.user.dfp_balance, 0)
                          : "0"
                      ) +
                      " DFP\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "usd-convert" }, [
                  _vm._v(
                    "\n              ~ $" +
                      _vm._s(
                        _vm.user !== null
                          ? _vm.$priceFormat(
                              _vm.user.dfp_balance * _vm.price,
                              2
                            )
                          : "0"
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-buttons" }, [
                _vm.user !== undefined && _vm.user !== null
                  ? _c(
                      "button",
                      {
                        staticClass: "btn pink smaller",
                        attrs: { type: "button" },
                        on: { click: _vm.googleform },
                      },
                      [
                        _vm._v(
                          "  \n              " +
                            _vm._s(_vm.$t("invest.buy_dfp")) +
                            "\n            "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn pink smaller",
                        attrs: { type: "button" },
                        on: { click: _vm.openConnectModal },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.connect_wallet")) +
                            "\n            "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _vm.user !== undefined && _vm.user !== null
                  ? _c(
                      "div",
                      {
                        staticClass: "btn pink smaller not_active",
                        attrs: { tooltip: _vm.$t("invest.soon") },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("invest.withdrawal")) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action-buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn pink",
                attrs: { type: "button" },
                on: { click: _vm.scrollToFaq },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("invest.how_to_buy")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "levels-area" }, [
        _c("div", { staticClass: "text-area" }, [
          _c("div", { staticClass: "subheader" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("invest.level_system")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "desc" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("invest.level_system_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "levels-list" }, [
            _c("div", { staticClass: "level-item" }, [
              _c("div", { staticClass: "list-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.token_purchases")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list-content" }, [
                _c("div", { staticClass: "icon-area" }, [_c("CheckFilled")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("invest.token_purchases_desc")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "level-item" }, [
              _c("div", { staticClass: "list-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.rules")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list-content" }, [
                _c("div", { staticClass: "icon-area" }, [_c("CheckFilled")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("invest.rules_desc")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "level-item" }, [
              _c("div", { staticClass: "list-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("invest.benefits")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list-content" }, [
                _c("div", { staticClass: "icon-area" }, [_c("CheckFilled")], 1),
                _vm._v(" "),
                _c("div", { staticClass: "text-area" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("invest.benefits_desc")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "table-area" }, [
          !_vm.levelsLoading && _vm.levelsTotal > 0
            ? _c(
                "div",
                { staticClass: "levels-table" },
                [
                  _c("div", { staticClass: "level-row th" }, [
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("invest.levels")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("invest.amount_of_tokens")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("invest.extra_tokens")) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.levels, function (level, index) {
                    return _c("div", { key: index, staticClass: "level-row" }, [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          {
                            staticClass: "icon",
                            style: {
                              background:
                                level.color !== null ? level.color : "#A577CE",
                            },
                          },
                          [
                            _c("div", { staticClass: "first-gradient" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "second-gradient" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(level.name) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$priceFormat(level.from, 0)) +
                            " - " +
                            _vm._s(_vm.$priceFormat(level.to, 0)) +
                            " DFP\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$priceFormat(level.discount, 1)) +
                            "%\n          "
                        ),
                      ]),
                    ])
                  }),
                ],
                2
              )
            : _vm.levelsLoading
            ? _c(
                "div",
                { staticClass: "levels-table" },
                [
                  _c("div", { staticClass: "level-row th" }, [
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("invest.levels")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("invest.amount_of_tokens")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("invest.extra_tokens")) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(10, function (index) {
                    return _c("div", { key: index, staticClass: "level-row" }, [
                      _c("div", { staticClass: "item" }, [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "title" },
                          [
                            _c("Skeleton", {
                              attrs: { width: "100px", height: "17px" },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "130px", height: "17px" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          _c("Skeleton", {
                            attrs: { width: "30px", height: "17px" },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "global-hr" }),
      _vm._v(" "),
      _c("div", { ref: "faqHeader", staticClass: "h2" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("invest.faqs")) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "faqs-area" },
        [
          _c("div", { ref: "faq1", staticClass: "faq" }, [
            _c(
              "div",
              {
                staticClass: "header-area",
                on: {
                  click: function ($event) {
                    return _vm.toggleFaq(1)
                  },
                },
              },
              [
                _c("div", { staticClass: "header-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("invest.faq_q1")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "answer-area" }, [
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("invest.faq_a1")) +
                    ":\n        "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "list" }, [
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_1")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_2")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_3")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_4")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_5")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_6")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "item" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("invest.faq_a1_7")) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { ref: "faq2", staticClass: "faq" }, [
            _c(
              "div",
              {
                staticClass: "header-area",
                on: {
                  click: function ($event) {
                    return _vm.toggleFaq(2)
                  },
                },
              },
              [
                _c("div", { staticClass: "header-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("invest.faq_q2")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(2),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "answer-area" }, [
              _c("p", { staticClass: "desc" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("invest.faq_a2", { price: _vm.price })) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(16, function (ind) {
            return _c(
              "div",
              {
                key: ind,
                ref: "faq" + (ind + 2),
                refInFor: true,
                staticClass: "faq",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "header-area",
                    on: {
                      click: function ($event) {
                        return _vm.toggleFaq(ind + 2)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "header-text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("invest.faq_q" + (ind + 2))) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(3, true),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "answer-area" }, [
                  _c("p", { staticClass: "desc" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("invest.faq_a" + (ind + 2))) +
                        "\n        "
                    ),
                  ]),
                ]),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud" },
        [_c("CloudCyanLiquidityLeft")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud2" },
        [_c("CloudCyanLiquidityRight")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("div", { staticClass: "first-gradient" }),
      _vm._v(" "),
      _c("div", { staticClass: "second-gradient" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-area" }, [
      _c("i", { staticClass: "bx bxs-chevron-down" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-area" }, [
      _c("i", { staticClass: "bx bxs-chevron-down" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-area" }, [
      _c("i", { staticClass: "bx bxs-chevron-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }